module.exports = __webpack_public_path__ + "img/ico-questions--black.21ed279f.svg";